export interface ActivityTimeLike {
  start_time?: unknown
  end_time?: unknown
  created_at?: unknown
  createdAt?: unknown
}

const isFiniteDate = (value: Date): boolean => Number.isFinite(value.getTime())

const normalizeEpochNumberToDate = (value: number): Date | null => {
  if (!Number.isFinite(value)) return null
  const timestampMs = Math.abs(value) < 1e12 ? value * 1000 : value
  const date = new Date(timestampMs)
  return isFiniteDate(date) ? date : null
}

export const parseTimestampToDate = (value: unknown): Date | null => {
  if (value == null || value === '') return null

  if (value instanceof Date) {
    return isFiniteDate(value) ? new Date(value.getTime()) : null
  }

  if (typeof value === 'number') {
    return normalizeEpochNumberToDate(value)
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return null

    if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
      return normalizeEpochNumberToDate(Number(trimmed))
    }

    const parsed = new Date(trimmed)
    return isFiniteDate(parsed) ? parsed : null
  }

  return null
}

export const resolveActivityDisplayTime = (activity: ActivityTimeLike): Date | null => {
  const candidates = [
    activity.start_time,
    activity.end_time,
    activity.created_at,
    activity.createdAt,
  ]

  for (const candidate of candidates) {
    const parsed = parseTimestampToDate(candidate)
    if (parsed) return parsed
  }

  return null
}
